import ImageIcon from '@mui/icons-material/Image';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

export function getFileIcon(contentType: string, size: number) {
  if (contentType === 'application/pdf') {
    return <PictureAsPdfIcon color="error" sx={{ fontSize: size }} />;
  }
  if (contentType.startsWith('image/')) {
    return <ImageIcon color="primary" sx={{ fontSize: size }} />;
  }
  return (
    <InsertDriveFileIcon sx={{ fontSize: size, color: 'text.secondary' }} />
  );
}
